import { render, staticRenderFns } from "./performance-description-read.component.vue?vue&type=template&id=50eb06df&scoped=true&"
import script from "./performance-description-read.component.vue?vue&type=script&lang=ts&"
export * from "./performance-description-read.component.vue?vue&type=script&lang=ts&"
import style0 from "./performance-description-read.component.vue?vue&type=style&index=0&id=50eb06df&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb06df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
